<template>
  <div v-if="h_screen" class="box">
    <div class="img-class">
      <img :src="src">
      <div class="tips">
        <div>{{ tips }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OriScreenTip',
  data() {
    return {
      src:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIYAAADaCAMAAABU68ovAAAAXVBMVEUAAAD29vb////x8fH////////x8fH5+fn29vby8vL////5+fn39/f6+vr////x8fH////////+/v7////09PT////x8fH39/f////////////////////x8fH///+WLTLGAAAAHXRSTlMAIpML+gb4ZhHWn1c2gvHBvq1uKJcC6k8b187lQ9yhhboAAAQYSURBVHja7d3blpowFIDhTUIAOchZDkre/zE7ycySrbUUpsRN2/1fzO18KzEqxEVgTiZNfgmmtxRc8iaR8HNe8x4BtjQePKayYCIoyBSgvNNE1AkNSHqZyLqk97EgUCCHBzZ5mkg7ScvIJuIyOyXBRFxgpqWZyGsAZLB1KjsJi8nutHU4JCRbFRH8tmirI9k8Jx2sqNs8K/m0LQkrktO2crgcgXGB4AiTEsB0hJfo9MGgX7CGcYiYwQxmMOOvZwRhBG8tCoMXjBDeXvWCEcHbi14wgCBmMIMZzGAGM5jxETNwzMAxA8cMHDNwzMAxA8cMHDNwzMAxA8cMHDNwzMAxY6E2rUQxnH2tz9cirlJFwFBJedaPnUv0M7++egPDE8iAJcIDmxwH5wwv9vUviw2kLbVO3TJU5uul/EyB0FoLp4x60PdGUd3qPurrWyjGGTc05u+1dcgI7/+tCCPARWGhH7o5Y7RCf+bH9ctXLp6v2BVDxfqz0oPXeSVaNtINo/1SXDv4dck8IIkbhtC2ol+iouEonTBCbYvVMnXOjxww6s/RFrBUpXHh/gw1rHj5d/qhYn9Gpk2FWh6xRBRX5Oj3Znh2Sq49/L6+y8pB26q9GbE2dbA2mVbx6I+7MfBglLCttm73ZQi7AD3iL4HqjFYJHSPRppqaUaJ3ATpGa+ckpGak2hRRMyqjGMkvl+xyFeSMwjAqcsZgGDdyhl0oNTnDN4yenJGZFGxNChP5/Y3efh6SM2rDOJMzboYxkDMqwyjIGcIw6F+io2FU1IxIm1JqRmgXSkvNKNCXeTpGrU0JNSO2c6LIGPgCS8AuDHz9ta0SXWDtxoDRH+MqlbC2Dt2G2JFRadtQZt2qq/orGowdGb2euxYiqWEpVWhTBnszoNAPdStuQwxqf0aocdWKW4Z+DfszIh8pxJqbuCE4YAC+4bm0evtipjpgJHeFnyyt1Ku2xa0bhjxr27p75rECNwyI9ZwvXkHq+7aTaMEV44YYy/spfgjgjNHaWW+GeUhGEX7tLlVinIFDDSgnOwhi1V6bU0b6tVS9eAERe863g4dRrtiHdc6o+nn5vtyVVgR79Cqt4uL6gfHPQyGqtP2vf7HADGbcYwaOGThm4JiBYwaOGThm4JiBYwaOGThm4JiBYwaOGThm4JiBYwaOGThm4JjhtOM+J/AgT008yDMkN/dPP9hzS8zAMQN3OEYeekp5YU7KOKXwVXqiY+QS7smcinGKABWdiBgpPJTSMHJ4KidhhPBUSMLw4CmPhKHgKUXCkHsygum71ftNSgCX6bsl8FQyfbcL5EdYsDk0R3j7aiA5wpt5AjKg/2gLJEBD/0Hf2OOf/vRrj6z/7GtP4B3nMKyjHA12kIPSjnJs3FEO0TvKkYJHOWCR+rjJH0Vn6fI5PjNbAAAAAElFTkSuQmCC',
      tips: '',
      onresize: null,
      h_screen: false
    }
  },
  computed: {
    // hScreenStatus() {}
  },
  mounted() {
    this.onresize = () => {
      this.checkScreen()
    }
    window.addEventListener('resize', this.onresize)
    window.addEventListener('orientationchange', this.onresize)
    this.checkScreen()
    this.checkTips()
    if (window.orientation === 90) {
      this.h_screen = false
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onresize)
    window.removeEventListener('orientationchange', this.onresize)
  },
  methods: {
    checkScreen() {
      if (window.innerWidth < window.innerHeight) {
        this.h_screen = true
      } else {
        this.h_screen = false
      }
    },
    isM() {
      var ua =
        navigator.userAgent /* navigator.userAgent 浏览器发送的用户代理标题 */
      if (
        ua.indexOf('Android') > -1 ||
        ua.indexOf('iPhone') > -1 ||
        ua.indexOf('iPod') > -1 ||
        ua.indexOf('Symbian') > -1
      ) {
        return true
      } else {
        return false
      }
    },
    isWebchat() {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i).toString() === 'micromessenger') {
        return true
      }
      // console.log(typeof ua.match(/MicroMessenger/i).toString(), ua.match(/MicroMessenger/i).toString() === 'micromessenger')
      return false
    },
    checkTips() {
      this.tips = '为了您的体验,请将手机系统“旋转”打开后进行横屏观看'
      console.log('手机')
      if (this.isWebchat()) {
        this.tips =
          '为了您的体验。请打开系统“旋转”功能，并在打开微信“设置”->“通用”->“开启横屏模式”后横屏观看'
        // console.log('微信')
      } else if (!this.isM()) {
        this.tips = '为了您的体验，请将浏览器调整为横屏'
        // console.log('浏览器')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: #303030, $alpha: 1);
  display: table;
  .img-class {
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    img {
      //   transform: rotate(60deg);
      animation: go 2s ease 0s infinite;
      margin-bottom: 100px;
    }
  }
  .tips {
    // display: table-cell;
    // text-align: center;
    width: 100%;
    // display: inline-block;
    margin-top: 300px;
    color: white;
    font-size: 100px;
    line-height: 27px;
    text-align: center;
    div {
      text-align: left;
      display: inline-block;
      max-width: 80%;
    //   background-color: black;
      word-break: break-all;
      line-height: 150px;
    }
    // max-width: 300px;
  }
}
@keyframes go {
  from {
    /*0%*/
    transform: rotate(30deg);
  }
  to {
    /*100%*/
    transform: rotate(60deg);
  }
}
</style>
